import { useEffect, useState } from 'react';

import {
  billingStatus,
  type BillingBlockStatus,
} from '@app/services/__global__/billingStatus';

export const useBillingStatus = (): BillingBlockStatus | null => {
  const [status, setStatus] = useState<BillingBlockStatus | null>(
    billingStatus.status
  );

  useEffect(() => billingStatus.subscribe(setStatus), []);

  return status ?? null;
};
